import type {
  RemittanceSource,
  RemittanceStatus,
} from '../../services/api/types.gen';

/**
 * Display strings for remittance status/source. These live outside
 * `RemittanceManager` because the manager imports `RemittanceTableToolbar`, so
 * the toolbar cannot import them back from the manager without a cycle. Both the
 * filter dropdowns and the rendered table cells read from here, keeping one
 * source of truth.
 */
export const STATUS_LABELS: Record<RemittanceStatus, string> = {
  saved: 'Saved',
  completed: 'Completed',
};

export const STATUS_VARIANTS: Record<RemittanceStatus, string> = {
  saved: 'text-amber-700 border-amber-300 bg-amber-50',
  completed: 'text-green-700 border-green-300 bg-green-50',
};

export const SOURCE_LABELS: Record<RemittanceSource, string> = {
  stedi_webhook: 'Stedi Webhook',
  manual_upload: 'Manual Upload',
  manual_entry: 'Manual Entry',
};

export const SOURCE_FILTER_OPTIONS = (
  Object.keys(SOURCE_LABELS) as RemittanceSource[]
).map(v => ({ value: v, label: SOURCE_LABELS[v] }));
